import React, { useEffect, useState, useMemo } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import LOGO from "../../utils/SVG/LOGO-BRANCA.svg";

import "../../utils/font-roboto.scss";
import "./index.scss";
import { useTranslation } from "react-i18next";

import IMG1 from "../../utils/IMG/THUMBS/Banner-1.jpg";
import IMG2 from "../../utils/IMG/THUMBS/Banner-2.jpg";
import IMG3 from "../../utils/IMG/THUMBS/Banner-3.jpg";
import IMG4 from "../../utils/IMG/THUMBS/Banner-4.jpg";
import IMG5 from "../../utils/IMG/THUMBS/Banner-5.jpg";

import IMG1_MINI from "../../utils/IMG/THUMBS/Banner-1-mini.jpg";
import IMG2_MINI from "../../utils/IMG/THUMBS/Banner-2-mini.jpg";
import IMG3_MINI from "../../utils/IMG/THUMBS/Banner-3-mini.jpg";
import IMG4_MINI from "../../utils/IMG/THUMBS/Banner-4-mini.jpg";
import IMG5_MINI from "../../utils/IMG/THUMBS/Banner-5-mini.jpg";

const Carrossel = () => {
  const { t, i18n } = useTranslation();

  const CARROSSEL = useMemo(
    () => [
      {
        index: 1,
        scr_img: IMG1,
        scr_img_mini: IMG1_MINI,
        msg_destaque: t("carrossel.item_1.msg_destaque"),
        msg_destaque_bold: t("carrossel.item_1.msg_destaque_bold"),
        msg_texto: t("carrossel.item_1.msg_texto"),
        msg_texto_bold: t("carrossel.item_1.msg_texto_bold"),
      },
      {
        index: 2,
        scr_img: IMG2,
        scr_img_mini: IMG2_MINI,
        msg_destaque: t("carrossel.item_2.msg_destaque"),
        msg_destaque_bold: t("carrossel.item_2.msg_destaque_bold"),
        msg_texto: t("carrossel.item_2.msg_texto"),
        msg_texto_bold: t("carrossel.item_2.msg_texto_bold"),
      },
      {
        index: 3,
        scr_img: IMG3,
        scr_img_mini: IMG3_MINI,
        msg_destaque: t("carrossel.item_3.msg_destaque"),
        msg_destaque_bold: t("carrossel.item_3.msg_destaque_bold"),
        msg_texto: t("carrossel.item_3.msg_texto"),
        msg_texto_bold: t("carrossel.item_3.msg_texto_bold"),
      },
      {
        index: 4,
        scr_img: IMG4,
        scr_img_mini: IMG4_MINI,
        msg_destaque: t("carrossel.item_4.msg_destaque"),
        msg_destaque_bold: t("carrossel.item_4.msg_destaque_bold"),
        msg_texto: t("carrossel.item_4.msg_texto"),
        msg_texto_bold: t("carrossel.item_4.msg_texto_bold"),
      },
      {
        index: 5,
        scr_img: IMG5,
        scr_img_mini: IMG5_MINI,
        msg_destaque: t("carrossel.item_5.msg_destaque"),
        msg_destaque_bold: t("carrossel.item_5.msg_destaque_bold"),
        msg_texto: t("carrossel.item_5.msg_texto"),
        msg_texto_bold: t("carrossel.item_5.msg_texto_bold"),
      },
    ],
    [t, i18n.language],
  );

  const [bannerSelecionado, setBannerSelecionado] = useState(CARROSSEL[0]);
  const [acao, setAcao] = useState("avancar");

  const ThumbItem = ({ item, index }) => {
    return (
      <div
        className={`thumb ${
          bannerSelecionado?.index === item?.index && "thumb-atual"
        }`}
        id={index}
        key={index}
        style={{
          backgroundImage: `url(${item?.scr_img_mini})`,
        }}
        onClick={() => {
          setBannerSelecionado(item);
          if (bannerSelecionado?.index !== item?.index) {
            resetarAnimacao();
          }
        }}
      >
        <div
          className={` ${
            bannerSelecionado?.index !== item?.index
              ? "thumb-inativo"
              : "thumb-ativo"
          }`}
        />
      </div>
    );
  };

  const ThumbAtivo = ({ img, destaque, destaque_bold, texto, texto_bold }) => {
    return (
      <div className="ativo">
        <div
          className="div-imagem"
          style={{
            animation: `${
              acao === "avancar" ? "frameViewAvancar" : "frameViewRetornar"
            } 10s ease-out 0s infinite normal none`,
          }}
        >
          <div
            className="imagem"
            style={{
              backgroundImage: `url(${img})`,
            }}
          />
        </div>
        <div className="informacoes">
          <div
            className="logo"
            style={{
              backgroundImage: `url(${LOGO})`,
            }}
          />
          <div
            className="caixa-textos"
            style={{
              animation: `${
                acao === "avancar" ? "frameViewAvancar" : "frameViewRetornar"
              } 10s ease-out 0s infinite normal none`,
            }}
          >
            <div className="destaque regular px24">{destaque}</div>
            <div className="informacao1 bold px36">{destaque_bold}</div>
            <div
              className="informacao2 light px40"
              style={{ whiteSpace: "pre-line" }}
            >
              {texto}
            </div>
            <div
              className="informacao3 bold px40"
              style={{ whiteSpace: "pre-line" }}
            >
              {texto_bold}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const interacaoManualBanner = (interacao) => {
    resetarAnimacao();
    const posicaoAtual = CARROSSEL?.findIndex(
      (item) => bannerSelecionado?.index === item?.index,
    );

    if (posicaoAtual === -1) return;

    if (posicaoAtual === 0 && interacao === "retornar") {
      return setBannerSelecionado(CARROSSEL[CARROSSEL?.length - 1]);
    }

    const totalBanners = CARROSSEL?.length || 0;

    if (interacao === "avancar") {
      const avancar = (posicaoAtual + 1) % totalBanners;
      setBannerSelecionado(CARROSSEL[avancar]);
    } else if (interacao === "retornar") {
      const retornar = (posicaoAtual - 1) % totalBanners;
      setBannerSelecionado(CARROSSEL[retornar]);
    }
  };

  const resetarAnimacao = () => {
    const background = document.getElementById("fundo-carrosel");
    background.style.animation = "none";
    setTimeout(() => {
      background.style.animation =
        "frameViewFundo 10s linear 0s infinite normal none";
    }, 10);
  };

  useEffect(() => {
    const avancarBanner = () => {
      resetarAnimacao();
      const posicaoAtual = CARROSSEL?.findIndex(
        (item) => bannerSelecionado?.index === item?.index,
      );
      setAcao("avancar");
      const proximaPosicao = (posicaoAtual + 1) % CARROSSEL?.length;
      setBannerSelecionado(CARROSSEL[proximaPosicao]);
    };
    const timer = setInterval(avancarBanner, 10000);
    return () => {
      clearInterval(timer);
    };
  }, [bannerSelecionado]);

  useEffect(() => {
    const atual = CARROSSEL.find(
      (item) => item.index === bannerSelecionado.index,
    );
    if (atual) setBannerSelecionado(atual);
  }, [CARROSSEL, bannerSelecionado.index]);

  return (
    <div
      className={`fundo-carrosel`}
      id="fundo-carrosel"
      style={{
        backgroundImage: `url(${bannerSelecionado?.scr_img})`,
      }}
    >
      <div className="fundo-blur">
        <div className="conteudo">
          <div className="seta">
            <FontAwesomeIcon
              icon={faChevronLeft}
              onClick={() => {
                interacaoManualBanner("retornar");
                setAcao("retornar");
              }}
            />
          </div>
          <div
            className="carrossel"
            style={{
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ThumbAtivo
              img={bannerSelecionado?.scr_img}
              destaque={bannerSelecionado?.msg_destaque}
              destaque_bold={bannerSelecionado?.msg_destaque_bold}
              texto={bannerSelecionado?.msg_texto}
              texto_bold={bannerSelecionado?.msg_texto_bold}
            />
            <div className="lista-carrossel" style={{ display: "none" }}>
              {CARROSSEL?.map((item, index) => {
                return <ThumbItem item={item} key={index} index={index} />;
              })}
            </div>
          </div>
          <div className="seta">
            <FontAwesomeIcon
              icon={faChevronRight}
              onClick={() => {
                interacaoManualBanner("avancar");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carrossel;
